export const filterContainerAnimation = {
  open: {
    opacity: 1,
    width: 'auto',
    transition: {
      duration: 0.3,
      when: 'beforeChildren',
      staggerChildren: 0.1,
    },
  },
  collapsed: {
    opacity: 0,
    width: 0,
    transition: {
      duration: 0.3,
    },
  },
};

export const filterItemAnimation = {
  collapsed: {
    opacity: 0,
    x: 20,
    transition: {
      duration: 0.2,
    },
  },
  open: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.2,
    },
  },
};

export const fadeUp = {
  initial: {
    opacity: 0,
    y: 10,
    transition: {
      duration: 0.3,
    },
  },
  in: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
    },
  },
  out: {
    opacity: 0,
    y: 10,
    transition: {
      duration: 0.3,
    },
  },
};

export const pageVariants = {
  initial: {
    opacity: 0,
    x: '-100vw',
  },
  in: {
    opacity: 1,
    x: 0,
  },
  out: {
    opacity: 0,
    x: '100vw',
  },
};

export const slideUp = {
  initial: {
    opacity: 0,
    y: 40,
    transition: {
      duration: 0.3,
    },
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
    },
  },
  exit: {
    opacity: 0,
    y: -40,
    transition: {
      duration: 0.3,
    },
  },
};

export const wildWidth = {
  initial: {
    width: 40,
    backgroundColor: '#000', // Initial background color
    transition: {
      duration: 0.4,
    },
  },
  animate: (isCartItem: boolean) => ({
    width: isCartItem ? 'auto' : 40,
    backgroundColor: isCartItem ? '#000' : '#000', // Animated background color
    transition: {
      duration: 0.5,
      when: 'beforeChildren',
      staggerChildren: 0.3,
    },
  }),
};

export const childVariants = {
  initial: { opacity: 0, y: 20, transition: { duration: 0.3 } },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.3, staggerChildren: 0.1 },
  },
  exit: { opacity: 0, y: -20, transition: { duration: 0.3 } },
};

export const rollingVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: (i: number) => ({
    y: 0,
    opacity: 1,
    transition: {
      delay: i * 0.1, // Adjust the stagger delay here
      type: 'spring',
      stiffness: 100,
    },
  }),
  exit: { y: -20, opacity: 0, transition: { duration: 0.2 } },
};
